module.exports = __webpack_public_path__ + "static/media/forgot-img.7b171500.jpg";